import { CSSProperties } from "react";

interface PaneProps {
    vertical?: boolean;
    primary?: boolean;
    size?: number | null;
    percentage?: boolean;
    children?: React.ReactNode | React.ReactNode[];
}

function Pane(props: PaneProps) {
    const size = props.size;
    const unit = props.percentage ? "%" : "px";
    let classes = "layout-pane";
    const style: CSSProperties = {};
    if (!props.primary) {
        if (props.vertical) {
            style.height = `${size}${unit}`;
        } else {
            style.width = `${size}${unit}`;
        }
    } else {
        classes += " layout-pane-primary";
    }
    return (
        <div className={classes} style={size ? style : undefined}>
            {props.children}
        </div>
    );
}

export default Pane;
